<template>
  <section>
    <div class="desc">
      <p>{{ $t('promotion.welcomeBonus.welcomeBonusDesc.line1') }}</p>
      <p>{{ $t('promotion.welcomeBonus.welcomeBonusDesc.line2') }}</p>
      <p>{{ $t('promotion.welcomeBonus.welcomeBonusDesc.line3') }}</p>
    </div>
    <Slogan class="redeposit-bonus-slogan" />
    <div class="divide-line"></div>
    <div class="tnc-wrapper">
      <p>
        <i18n path="promotion.welcomeBonus.tnc">
          <template v-slot:link>
            <a
              href="https://www.vtmarketscn.com/promotions/deposit-bonus/july-one/"
              target="_blank"
              data-testid="tnc"
              >{{ $t('promotion.welcomeBonus.link') }}</a
            >
          </template>
        </i18n>
      </p>
      <div class="btn-wrapper" v-if="accountInfo">
        <CustomButton :styleConfig="cancelCampaignBtnConfig" @click="showPopOut = true">{{
          $t('common.cancelCampaign')
        }}</CustomButton>
      </div>
    </div>
    <PopOut
      :visible.sync="showPopOut"
      :message="$t('promotion.welcomeBonus.dialog.optOut.desc')"
      :confirmText="$t('promotion.welcomeBonus.dialog.optOut.confirm')"
      :cancelText="$t('promotion.welcomeBonus.dialog.optOut.cancel')"
      @confirm="optOut"
    ></PopOut>
    <PopOut
      :visible.sync="isBlacklisted"
      :message="$t('promotion.redepositBonus.dialog.blacklist.desc')"
      :confirmText="$t('promotion.redepositBonus.dialog.blacklist.confirm')"
      :hideCancel="true"
    ></PopOut>
    <PopOut
      :visible.sync="isCampaignEnd"
      :message="$t('promotion.redepositBonus.dialog.campaignEnd.desc')"
      :confirmText="$t('promotion.redepositBonus.dialog.campaignEnd.confirm')"
      :hideCancel="true"
    ></PopOut>
  </section>
</template>

<script>
import Slogan from './Slogan.vue';
import CustomButton from '@/components/interact/CustomButton.vue';
import PopOut from '../reDepositBonus/PopOut.vue';
import { BLACK_COLOR, GREEN_COLOR, RED_COLOR } from '@/constants/style';
import { apiOptOutAcc } from '@/resource';

const cancelCampaignBtnConfig = {
  BTN_DEFAULT: {
    bgColor: RED_COLOR,
    color: '#ffffff',
    border: `2px solid ${RED_COLOR}`,
    borderRadius: '34px',
    padding: '15px 53px',
    fontSize: '21px',
    lineHeight: 'normal',
    fontWeight: 500
  },
  BTN_HOVER: {
    bgColor: GREEN_COLOR,
    color: BLACK_COLOR,
    border: `2px solid ${GREEN_COLOR}`,
    borderRadius: '34px',
    padding: '15px 53px',
    fontSize: '21px',
    lineHeight: 'normal',
    fontWeight: 500
  }
};

export default {
  name: 'CampaignConditions',
  components: {
    Slogan,
    CustomButton,
    PopOut
  },
  props: {
    accountInfo: {
      type: Object,
      default: {
        participants: [],
        in: null,
        reachedMaximumBonus: null,
        creditLimit: null,
        welcomeRateLimit: null,
        showOptInPopup: null,
        hasDepositRecord: null,
        expired: null,
        expiring: null,
        expiredDate: null,
        status: null,
        lotsTraded: null,
        accountType: null,
        mt4Account: null
      }
    },
    campaignId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      cancelCampaignBtnConfig,
      showPopOut: false,
      isBlacklisted: false,
      isCampaignEnd: false
    };
  },
  computed: {
    userId() {
      return this.$store.state.common.uuid;
    }
  },
  watch: {
    accountInfo(val) {
      if (val.status === 'B') this.isBlacklisted = true;
      else if (val.status === 'X') this.isCampaignEnd = true;
    }
  },
  methods: {
    optOut() {
      let body = {
        campaignId: this.campaignId,
        userId: this.userId,
        accountMt4Dto: {
          mt4Account: this.accountInfo.mt4Account,
          currency: this.accountInfo.currency,
          datasourceId: this.accountInfo.datasourceId
        }
      };
      apiOptOutAcc(body)
        .then(resp => {
          if (resp.data.data) {
            this.$message({
              message: this.$t('common.field.successful'),
              type: 'success'
            });
            this.$router.push('/home');
          }
        })
        .catch(e => {
          this.$message({
            message: this.$t('common.field.failed'),
            type: 'error'
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.desc {
  color: $broker-black;
  margin-top: 80px;
  text-align: center;
  font-family: Oblivian, PingFangTC-SemiBold;

  p {
    font-weight: 600;
    font-size: 21px;
    line-height: 135%;
    margin-bottom: 5px;
  }
}

.redeposit-bonus-slogan {
  margin-top: 104px;
  margin-bottom: 80px;
}

.divide-line {
  height: 1px;
  width: 100%;
  border-bottom: solid 1px rgba(151, 151, 151, 0.58);
  margin: 0 auto;
}

.tnc-wrapper {
  margin-top: 81px;
  font-size: 21px;
  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    margin-top: 30px;
  }
}
.btn-wrapper {
  margin-top: 30px;
  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    gap: 20px;
  }
}
</style>
